import React, { useState, useEffect, useContext, useRef } from 'react'
import { Form, Link, useParams } from 'react-router-dom'
import AdminContext from '../../../StateContext/Application'
import { Cancel32, submit, UploadBill32 } from '../../../../../public/LoginImages/importimages'

const UploadBill = () => {
  const context = useContext(AdminContext)
  const { GetVendors, UploadBills, getTaxes } = context
  const [vendor, setVendor] = useState([])
  const [formData, setFormData] = useState({ Vendor_Company_Name: '' });
  const [gst, setGst] = useState(0)
  const [tds, setTds] = useState(0)
  const [security, SetSecurity] = useState(0)
  const [totalpaid, SetTotalPaid] = useState(0)
  const [Taxes, setTaxes] = useState([])
  const formdataref = useRef(null)

  const getVendors = async () => {
    let data = await GetVendors()
    setVendor(data)
  }
  useEffect(() => {
    getVendors();
    GetTaxes()
  }, [])

  const GetTaxes = async () => {
    let data = await getTaxes()
    console.log(data);
    setTaxes(data)
  }
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (value < 0) {
      alert(`cannot be negative`);
      setFormData((prevData) => ({
        ...prevData,
        [name]: '',
      }));
      return;

    }
    setFormData((prevData) => ({
      ...prevData,
      [name]: value, // Dynamically update formData with the field name
    }));
  };

  useEffect(() => {
    if (formData.Total_Payment_Amt) {
      const totalPayment = Number(formData.Total_Payment_Amt);
      const calculatedGst = Math.ceil(totalPayment * 18 / 100);
      const calculatedTds = Math.ceil(totalPayment * 12 / 100);
      const calculatedSecurity = Math.ceil(totalPayment * 2 / 100);
      const totalTax = calculatedGst + calculatedTds + calculatedSecurity;
      const calculatedTotalPaid = totalPayment - totalTax;

      setGst(calculatedGst);
      setTds(calculatedTds);
      SetSecurity(calculatedSecurity);
      SetTotalPaid(calculatedTotalPaid);

      setFormData((prev) => ({
        ...prev,
        GST: calculatedGst,
        TDS: calculatedTds,
        SecurityFee: calculatedSecurity,
        TotalAmountPayToVendor: calculatedTotalPaid
      }));
    }
  }, [formData.Total_Payment_Amt]);

  const handleSubmit = async (e) => {
    console.log(formData);
    e.preventDefault();
    if (formData.Vendor_Company_Name === '') {
      alert('Please select a vendor')
      return
    }
    console.log(formData);

    let data1 = await UploadBills(formData)
    if (data1) {
      alert(data1.message)
      window.location.reload()
    }
    else {
      alert('failed')
    }
  };
  const resetData = () => {
    formdataref.current.reset()
    setFormData([])
  }
  return (
    <div style={{ padding: '20px', backgroundColor: "#f4f7fe", overflowY: 'auto', maxHeight: '91vh' }}>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <div style={{ marginTop: 20, display: 'flex', width: '70vw', border: 'none', padding: '30px', background: 'linear-gradient(to Right, #B2E0F2 , #B7D7EA , #B2D1E6 , #C4C5E2 )', borderRadius: '10px', }}>
          <label className='form-label col-2' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: '600' }}>Select Vendor</label>
          <select style={{ boxShadow: '0px 0px 4px' }} class="form-select" aria-label="Default select example" name="Vendor_Company_Name" onChange={handleInputChange} aria-required>
            <option selected disabled >Select Vendor</option>
            {vendor && vendor.map((e) => (
              <option className="form-control " name="Vendor_Company_Name" value={e.Bidder_CompanyName} id={e.Bidder_CompanyName}>{e.Bidder_CompanyName}</option>
            ))}
          </select>
        </div>
      </div>
      <Form onSubmit={handleSubmit} ref={formdataref} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <div style={{ marginTop: 20, display: 'grid', gap: '2rem', width: '70vw', border: 'none', padding: '30px', backgroundColor: 'white', borderRadius: '10px', flexWrap: "wrap", }}>
          <div style={{ display: 'flex', justifyContent: 'start', alignItems: 'center',gap:'5px' }}>
            <img src={UploadBill32} style={{paddingBottom:'7px'}}/>
            <h6 style={{ background: 'linear-gradient(to bottom, #3b409e, #0067ab, #0f79ba, #0098d5)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',fontWeight:'700' }}> Upload Bill</h6>
          </div>
          <div style={{ display: 'flex' }} className="col-12">
            <label className='form-label col-4' style={{ fontWeight: '700' }}>Total Payment Amount</label>
            <input
              type="number"
              className="form-control " style={{ border: '1px solid darkgray', borderBottom: '1px solid #857979' }}
              id="Total_Payment_Amt"
              name="Total_Payment_Amt"
              placeholder='Enter Total Amount'
              value={formData?.Total_Payment_Amt}
              onChange={handleInputChange}
              required
            />
          </div>
          {Taxes && Taxes.map((tax) => {
            const normalizedKey = tax.Tax_Name.replace(/\s+/g, ""); // Remove spaces from the key
            return (
              <div key={tax.ID} style={{ display: 'flex', marginTop: '10px' }} className="col-12">
                <label className='form-label col-4' style={{ fontWeight: '700' }}>{tax.Tax_Name}</label>
                <input
                  type="number"
                  className="form-control"
                  style={{ border: '1px solid darkgray', borderBottom: '1px solid #857979' }}
                  id={`Tax_${tax.ID}`}
                  name={normalizedKey} // Store key without spaces
                  value={formData?.[normalizedKey] || ""}
                  placeholder={`Enter ${tax.Tax_Name}`}
                  onChange={handleInputChange}
                  required
                />
              </div>
            );
          })}
          {/* <div style={{ display: 'flex' }} className="col-12">
            <label className='form-label col-4' style={{ fontWeight: '600' }}>GST</label>
            <input
              type="number"
              className="form-control " style={{ border: '1px solid darkgray', borderBottom: '1px solid #857979' }}
              id="GST"
              name="GST"
              value={gst}
              onChange={handleInputChange}
              required
            />
          </div>
          <div style={{ display: 'flex' }} className="col-12">
            <label className='form-label col-4' style={{ fontWeight: '600' }}>TDS</label>
            <input
              type="number"
              className="form-control" style={{ border: '1px solid darkgray', borderBottom: '1px solid #857979' }}
              id="TDS"
              name="TDS"
              value={tds}
              onChange={handleInputChange}
              required
            />
          </div>
          <div style={{ display: 'flex' }} className="col-12">
            <label className='form-label col-4' style={{ fontWeight: '600' }}>Security Fee</label>
            <input
              type="number"
              className="form-control" style={{ border: '1px solid darkgray', borderBottom: '1px solid #857979' }}
              id="TDS"
              name="SecurityFee"
              value={security}
              onChange={handleInputChange}
              required
            />
          </div> */}
          <div style={{ display: 'flex' }} className="col-12">
            <label className='form-label col-4' style={{ fontWeight: '700' }}>Total Amount To Be Paid To Vendor</label>
            <input
              type="number"
              className="form-control" style={{ border: '1px solid darkgray', borderTop: '1px solid #857979' }}
              id="TotalAmountPayToVendor"
              name="TotalAmountPayToVendor"
              //  placeholder={TotalPaymentAmt}
              value={totalpaid}
              onChange={handleInputChange}
              disabled
            />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
            <button type="submit" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: "20px", width: "7rem", height: "2.5rem", background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', border: 'none', fontSize: '17px', gap: '4px' }}><img src={submit} style={{ width: '1.2rem', paddingBottom: '3px', fontSize: '15px' }} />Submit </button>
            <button onClick={resetData} type='button' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: "20px", width: "7rem", height: "2.5rem", backgroundColor: 'red', border: 'none', fontSize: '17px', gap: '4px' }}><img src={Cancel32} style={{ width: '1.2rem', }} /> Cancel</button>
          </div>
        </div>

      </Form>
    </div>
  )
}

export default UploadBill